import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'slick-carousel/slick/slick.css'
import './assets/scss/styles.scss'
import AppConstant from './config/app-constant'
import PathConstant from './config/path-constant'
import Axios from 'axios'
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'
import VeeValidate from "vee-validate"
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueI18n from 'vue-i18n'
import { languages } from './config/locales/index'
import { defaultLocale } from './config/locales/index'
Vue.use(VueI18n)
const messages = Object.assign(languages)
var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'TH',
  messages
})
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Loading, {
  color: '#003168',
  loader: 'dots',
  width: 50,
  height: 50,
  backgroundColor: '#ffffff',
  opacity: 0.7,
  zIndex: 99999,
});
Vue.use({
  install(Vue) {
    Vue.prototype.$http = Axios
    Vue.prototype.$app = AppConstant
    Vue.prototype.$path = PathConstant
  }
})
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "$veeFields",
  errorBagName: "$veeErrors"
});

Vue.config.productionTip = false
Vue.filter('numFormat', numFormat(numeral))
Vue.mixin({
  methods: {
    toastSaveSuccess() {
      this.$bvToast.toast('บันทึกสำเร็จ', {
        title: 'บันทึก',
        autoHideDelay: 5000,
        appendToast: false,
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-right'
      })
    },
    toastSaveWarning() {
      this.$bvToast.toast('ไม่สามารถบันทึกได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง', {
        title: 'แจ้งเตือน',
        autoHideDelay: 5000,
        appendToast: false,
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-right'
      })
    },
    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title || 'แจ้งเตือน',
        autoHideDelay: 5000,
        appendToast: false,
        variant: variant || 'default',
        solid: true,
        toaster: 'b-toaster-top-right'
      })
    },
    changeLocale(lang) {
      i18n.locale = lang
      localStorage.setItem('lang', lang)
    },
    truncate(str){
      return (str.length > 35) ? str.substr(0, 35-1) + '...' : str;
    }
  }
})
new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')